import React from "react";
import { connect, ConnectedProps } from "react-redux";

import { closeDialog, repairBuilding } from "../../../store/actions";

interface IProps {
  slot: any,
  gold: number,
  bricks: number
}
const mapDispatchToProps = (dispatch: any) => ({
  closeDialog: () => dispatch(closeDialog()),
  repairBuilding: (slotId: number) => dispatch(repairBuilding(slotId))
})

const connector = connect(null, mapDispatchToProps);

const RepairBuilding = (props: IProps & ConnectedProps<typeof connector>) => (
  <>
    <div className="dialog-content">
      <table className="table">
        <tr>
          <td>
            <strong className={"white"}>
              Repair cost <em>{props.slot.repairPrice}</em> <i className="icon icon-sm gold icon-zlato align-sub"/>
              + <em>{props.slot.repairPrice * 2}</em> <i className="icon icon-sm icon-infrastrukturni-body align-sub"/>
              + <em>{props.slot.repairTurns}</em> turns
            </strong>
          </td>
        </tr>
        {props.slot.repairPrice > props.gold || props.slot.repairPrice > props.bricks
          ? <tr>
            <td className="negative text-center">
              Not enough resources
            </td>
          </tr> : <></>
        }
      </table>
    </div>
    <footer className="dialog-footer">
      <a className="btn btn-blank btn-no-width" onClick={props.closeDialog}>CANCEL</a>
      <a
         onClick={() => props.repairBuilding(props.slot.id)}
         className={`btn btn-blank btn-no-width ${props.slot.repairPrice > props.gold || props.slot.repairPrice > props.bricks
           ? "disabled" : ""}`}
      >REPAIR</a>
    </footer>
  </>
)

export default connector(RepairBuilding);
